// @flow
/* eslint-disable no-underscore-dangle, no-param-reassign */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const formatter = (args: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'RstState',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem, args: formatterArgs }) => {
      const { RstState } = dataItem;
      const selectedState = (formatterArgs && formatterArgs.selectedState);

      let color;

      if (
        !dataItem.__processed &&
        ((RstState === 'NJ ONLY' && selectedState !== 'J') ||
          (RstState === 'NY ONLY' && selectedState !== 'Y') ||
          (RstState === 'NO NJ RETAIL' && selectedState === 'J'))
      ) {
        color = 'yellow';
        // eslint-disable-next-line
        dataItem.__processed = true;
      }

      if (!color || !dataItem.__processed) {
        return;
      }

      wjcCore.addClass(elem.cell, color);
    },
    args,
  });

export default formatter;
